import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  padding: 10px;
`;
export const SubContainer = styled.div`
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.DESCRIPTION};
`;
export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Logo = styled.img`
  width: 30px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-right: 5px;
`;
export const Title = styled.h1`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 15px;
  font-weight: 500;
  align-items: center;
  margin: 0;

  @media (max-width: 360px) {
         font-size: 13px;
    }
     @media (max-width: 768px) {
       font-size: 13px;
    }

`;
export const Price = styled.h1`
  color: ${({ theme }) => theme.COLORS.SUCCESS};
  font-size: 17px;
  align-items: center;
  margin: 0;

  @media (max-width: 360px) {
         font-size: 13px;
    }
     @media (max-width: 768px) {
       font-size: 13px;
    }
`;